export const CELL_SIZE = 32;
export const GRID_WIDTH = 11;
export const GRID_HEIGHT = 20;
